import React from "react";
import { useTranslation } from "react-i18next";
import { AlertCircle } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";

const ApprovalPendingAlert = ({ pendingCount, onViewPending }) => {
  const { t } = useTranslation();

  return (
    <Card className="border-border bg-yellow-950/20">
      <CardContent className="pt-6">
        <div className="flex items-center gap-3">
          <AlertCircle className="h-5 w-5 text-yellow-400" />
          <div className="flex-1">
            <p className="font-medium text-foreground">
              {t("planning.approvalsPanel.pendingAlert", { count: pendingCount })}
            </p>
            <p className="text-sm text-muted-foreground">{t("planning.approvalsPanel.attention")}</p>
          </div>
          <Button variant="outline" size="sm" onClick={onViewPending}>{t("planning.approvalsPanel.view")}</Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ApprovalPendingAlert;
